<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="true" create-btn-title="新建展会"
                @btnHandler="btnHandler('addHandler')" @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.title" placeholder="展会标题" style="width: 300px;"></Input>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <DatePicker v-model="params.activity_date" type="datetimerange" placement="bottom-end" placeholder="选择日期" style="width: 310px"></DatePicker>
        </FormItem>
      </template>

      <template slot="images" slot-scope="{ row }">
        <div v-if="row.images" class="demo-upload-list">
          <img :src="row.images">
          <div class="demo-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView(row.images)"></Icon>
          </div>
        </div>
      </template>
      <template slot="share_image" slot-scope="{ row }">
        <div v-if="row.share_image" class="demo-upload-list">
          <img :src="row.share_image">
          <div class="demo-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView(row.share_image)"></Icon>
          </div>
        </div>
      </template>
      <template slot="register_join_images" slot-scope="{ row }">
        <div v-if="row.register_join_images" class="demo-upload-list">
          <img :src="row.register_join_images">
          <div class="demo-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView(row.register_join_images)"></Icon>
          </div>
        </div>
      </template>
      <template slot="register_provider_images" slot-scope="{ row }">
        <div v-if="row.register_provider_images" class="demo-upload-list">
          <img :src="row.register_provider_images">
          <div class="demo-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView(row.register_provider_images)"></Icon>
          </div>
        </div>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Tooltip content="下载小程序码" placement="top" transfer>
          <Button type="primary" size="small" icon="ios-cloud-download" style="margin-right: 5px"
                  @click="btnHandler('download', row)"/>
        </Tooltip>
        <Tooltip content="详情" placement="top" transfer>
          <Button type="primary" size="small" icon="md-eye" style="margin-right: 5px"
                  @click="btnHandler('details', row)"/>
        </Tooltip>
        <Tooltip content="编辑" placement="top" transfer>
          <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)"/>
        </Tooltip>
<!--        <Poptip-->
<!--          confirm-->
<!--          title="确定要删除吗?"-->
<!--          placement="left"-->
<!--          @on-ok="btnHandler('delete', row)"-->
<!--          @on-cancel="btnHandler('cancel', row)">-->
<!--          <Button type="warning" size="small" icon="md-trash"></Button>-->
<!--        </Poptip>-->
      </template>
    </page-table>

    <Drawer v-model="forumObj.show" :mask-closable="false" width="1000" :styles="styles" @on-close="closeForm">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{formItem.id ? '编辑' : '新建'}}展会</span>
        {{formItem.id }}
      </p>
      <Form ref="myForm" :rules="ruleValidate" :model="formItem" :label-width="110">
        <FormItem label="展会标题" prop="title">
          <Input type="text" v-model="formItem.title" placeholder="请输入标题"></Input>
        </FormItem>
        <Row>
          <Col span="12">
            <FormItem label="展会主图" prop="images">
              <div class="demo-upload-list">
                <img :src="formItem.images">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(formItem.images)"></Icon>
                </div>
              </div>
              <Upload ref="upload" :on-success="uploadSuccessImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
              <Tooltip placement="top" style="margin-left: 10px;">
                <Icon type="ios-alert" size="20" color="#ff9900" />
                <div slot="content">
                  <p>图片大小建议控制在400kb以下</p>
                  <p>分辨率宽高比建议：3(宽):2(高)</p>
                </div>
              </Tooltip>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="微信分享背景图" prop="register_provider_images">
              <div class="demo-upload-list">
                <img :src="formItem.share_image">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(formItem.share_image)"></Icon>
                </div>
              </div>
              <Upload ref="upload" :on-success="uploadSuccessShareImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
                <div style="width: 58px; height: 58px; line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
              <Tooltip placement="top" style="margin-left: 10px;">
                <Icon type="ios-alert" size="20" color="#ff9900" />
                <div slot="content">
                  <p>图片大小建议控制在400kb以下</p>
                  <p>分辨率为：750px(宽):1200px(高)</p>
                </div>
              </Tooltip>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="参展登记图" prop="register_provider_images">
              <div class="demo-upload-list">
                <img :src="formItem.register_provider_images">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(formItem.register_provider_images)"></Icon>
                </div>
              </div>
              <Upload ref="upload" :on-success="uploadSuccessRegisterProviderImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
              <Tooltip placement="top" style="margin-left: 10px;">
                <Icon type="ios-alert" size="20" color="#ff9900" />
                <div slot="content">
                  <p>图片大小建议控制在400kb以下</p>
                  <p>分辨率宽高比建议：3(宽):2(高)</p>
                </div>
              </Tooltip>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="参观登记图" prop="register_join_images">
              <div class="demo-upload-list">
                <img :src="formItem.register_join_images">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(formItem.register_join_images)"></Icon>
                </div>
              </div>
              <Upload ref="upload" :on-success="uploadSuccessRegisterJoinImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
              <Tooltip placement="top" style="margin-left: 10px;">
                <Icon type="ios-alert" size="20" color="#ff9900" />
                <div slot="content">
                  <p>图片大小建议控制在400kb以下</p>
                  <p>分辨率宽高比建议：3(宽):2(高)</p>
                </div>
              </Tooltip>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="参展价格" prop="provider_price">
              <InputNumber v-model="formItem.provider_price" placeholder="请输入参展价格" style="width: 150px;"></InputNumber>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="参观价格" prop="join_price">
              <InputNumber v-model="formItem.join_price" placeholder="请输入参观价格" style="width: 150px;"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="展会日期" prop="date">
              <Row>
                <Col span="12">
                  <Date-picker v-model="formItem.date" format="yyyy-MM-dd HH:mm" type="datetimerange" placement="bottom-start" placeholder="选择日期" style="width: 280px"></Date-picker>
                </Col>
              </Row>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="展会地址" prop="address">
              <Input v-model="formItem.address" placeholder="请输入地址"></Input>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="展会基本信息" prop="basic_info">
          <tinymce ref="basic_info" :height="300" v-model="formItem.basic_info" @input="formItem.basic_info = $event"></tinymce>
        </FormItem>
        <FormItem label="展会详情" prop="meeting_detail">
          <tinymce ref="meeting_detail" v-model="formItem.meeting_detail" @input="formItem.meeting_detail = $event"></tinymce>
        </FormItem>
        <FormItem label="参展费用" prop="meeting_agenda">
          <tinymce ref="meeting_agenda" v-model="formItem.meeting_agenda" @input="formItem.meeting_agenda = $event"></tinymce>
        </FormItem>
        <FormItem label="参展须知" prop="participation_notice">
          <tinymce ref="participation_notice" v-model="formItem.participation_notice" @input="formItem.participation_notice = $event"></tinymce>
        </FormItem>
      </Form>
      <div class="drawer-footer">
        <Button type="text" @click="closeForm" class="margin-right-10">取消</Button>
        <Button type="primary" @click="submit" :loading="forumObj.loading">确定</Button>
      </div>
    </Drawer>

    <Drawer v-model="detailDrawer.show" :title="detailDrawer.title" :mask-closable="false" width="1000">
      <detail :row-data="detailDrawer.rowData"></detail>
    </Drawer>

    <Modal title="大图预览" v-model="imageVisible">
      <img :src="imageName" v-if="imageVisible" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { deleteActivity, getActivityList, getXcxCode, releaseActivity } from '../../api/activity'
import { mapState } from 'vuex'
import { getToken } from '../../libs/util'
import Detail from './components/detail'
import tinymce from '../../components/tinymce/index'

export default {
  name: 'exhibition',
  components: { Detail, pageTable, tinymce },
  data () {
    return {
      img: '',
      params: {
        title: '',
        activity_date: [],
        type: 0
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      styles: {
        height: 'calc(100vh - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      formItem: {
        type: 0,
        title: '',
        images: '',
        share_image: '',
        register_provider_images: '',
        register_join_images: '',
        date: [],
        address: '',
        provider_price: 0,
        join_price: 0,
        basic_info: '',
        meeting_detail: '',
        meeting_agenda: '',
        participation_notice: ''
      },
      forumObj: {
        show: false,
        loading: false,
        index: 0
      },
      ruleValidate: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '地址不能为空', trigger: 'blur' }
        ],
        basic_info: [
          { required: true, message: '基本信息不能为空', trigger: 'blur' }
        ],
        meeting_detail: [
          { required: true, message: '会议详情不能为空', trigger: 'blur' }
        ],
        meeting_agenda: [
          { required: true, message: '会议议程不能为空', trigger: 'blur' }
        ],
        participation_notice: [
          { required: true, message: '参会须知不能为空', trigger: 'blur' }
        ]
      },
      detailDrawer: {
        show: false,
        loading: false,
        rowData: {},
        title: '详情'
      },
      imageVisible: false,
      imageName: ''
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: 'id', key: 'id', width: 80 },
        { title: '展会标题', key: 'title', width: 230 },
        { title: '展会主图', key: 'images', align: 'center', slot: 'images', width: 120 },
        { title: '微信分享图', key: 'share_image', align: 'center', slot: 'share_image', width: 120 },
        { title: '参展登记图', key: 'register_provider_images', align: 'center', slot: 'register_provider_images', width: 120 },
        { title: '参观登记图', key: 'register_join_images', align: 'center', slot: 'register_join_images', width: 120 },
        { title: '展会时间', key: 'activity_time', align: 'center', width: 150, tooltip: true },
        { title: '参观价格', key: 'join_price', align: 'center', width: 110 },
        { title: '参展价格', key: 'provider_price', align: 'center', width: 110 },
        { title: '创建人', key: 'create_by', align: 'center' },
        { title: '创建时间', key: 'create_time', align: 'center', width: 140 },
        { title: '操作', slot: 'action', width: 100, align: 'center', fixed: 'right' }
      ]
    },
    ...mapState({
      uploadConfig: state => {
        return state.app.uploadConfig
      }
    })
  },

  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getActivityList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },

    addHandler () {
      this.$refs['myForm'].resetFields()
      this.forumObj.show = true
      this.formItem = {
        type: 0,
        title: '',
        images: '',
        share_image: '',
        register_provider_images: '',
        register_join_images: '',
        date: [],
        address: '',
        provider_price: 0,
        join_price: 0,
        basic_info: '',
        meeting_detail: '',
        meeting_agenda: '',
        participation_notice: ''
      }
    },

    details (row) {
      this.detailDrawer.show = true
      const params = { ...row }
      params.date = [row.start_time, row.end_time]
      this.detailDrawer.rowData = params
    },
    delete (row) {
      deleteActivity({ id: row.id }).then(res => {
        this.$Message.info('删除成功')
        this.fetchData()
      })
    },
    edit (row) {
      const params = { ...row }
      params.date = [row.start_time, row.end_time]
      this.formItem = params
      this.forumObj.show = true
    },
    download (row) {
      this.tableLoading = true
      getXcxCode({ scene: 'id=' + row.id, page: 'pages/activity/exhibition/detail/index' }).then(({ data }) => {
        const image = new Image()
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

          const a = document.createElement('a') // 生成一个a元素
          const event = new MouseEvent('click') // 创建一个单击事件
          a.download = row.title // 设置图片名称
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
        }
        image.src = data
      }).finally(() => {
        this.tableLoading = false
      })
    },
    submit () {
      this.$refs['myForm'].validate((valid) => {
        if (valid) {
          this.formItem.type = 0
          this.forumObj.loading = true
          releaseActivity(this.formItem).then(res => {
            this.$Message.success(res.msg)
            this.forumObj.show = false
            this.forumObj.loading = false
            this.fetchData()
          }).finally(() => {
            this.forumObj.loading = false
          })
        }
      })
    },
    handleView (name) {
      this.imageName = name
      this.imageVisible = true
    },
    // 文件上传成功钩子函数
    uploadSuccessImg (response, file) {
      this.formItem.images = response.data.fileUrl
    },
    uploadSuccessRegisterJoinImg (response, file) {
      this.formItem.register_join_images = response.data.fileUrl
    },
    uploadSuccessRegisterProviderImg (response, file) {
      this.formItem.register_provider_images = response.data.fileUrl
    },
    uploadSuccessShareImg (response, file) {
      this.formItem.share_image = response.data.fileUrl
    },
    handleMaxSize (file) {
      const fileSize = (file.size / 1024 > 1000) ? (file.size / 1024 / 1024).toFixed(2) + 'M' : (file.size / 1024).toFixed(2) + 'KB'
      this.$Notice.warning({
        title: '超过文件大小限制',
        desc: '当前文件  ' + fileSize + ' 最大支持' + this.uploadConfig.maxFileSize + 'KB'
      })
    },
    closeForm () {
      this.$refs['myForm'].resetFields()
      this.forumObj.show = false
    }
  }
}
</script>

<style scoped>
  /deep/ .ql-editor {
    height: 150px;
  }

  .demo-upload-list{
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
